<mat-card appearance="outlined" class="history-card">
  <div class="header row">
    <button matRipple class="button">
      <fa-icon [icon]="['fas', 'angle-down']" size="lg"></fa-icon>
    </button>

    <div>
      <h2>Site history</h2>
      <span>No errors found</span>
    </div>
  </div>
</mat-card>
